<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">银行信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="bankinfoForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="银行名称" prop="name">
              <Input v-model="form.name" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="银行标识" prop="code">
              <Input v-model="form.code" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="子银行名称" prop="subName">
              <Input v-model="form.subName" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="查询银行信息关键字" prop="findKey">
              <Input v-model="form.findKey" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="邮件查询关键字" prop="mailKey">
              <Input v-model="form.mailKey" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="java的bean类" prop="beanName">
              <Input v-model="form.beanName" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="是否有电子签名(0，未知，1是，2否)" prop="hasSign">
              <Input v-model="form.hasSign" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="电子签关键字" prop="signName">
              <Input v-model="form.signName" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="固定结息日期" prop="settlementDate">
              <Input v-model="form.settlementDate" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="结息关键字" prop="settlementKey">
              <Input v-model="form.settlementKey" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Divider plain>活期利率</Divider>
        <div v-for="(item, index) in bankRates" :key="index">
          <Row>
            <Col span="7">
              <FormItem label="活期年利率（%）" >
                <Input v-model="item.currentRate" :disabled="disable"></Input>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="开始日期" >
                <DatePicker v-model="item.startTime" :disabled="disable" type="date" format="yyyy-MM-dd" />
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label="结束日期" >
                <DatePicker v-model="item.endTime" :disabled="disable" type="date" format="yyyy-MM-dd" />
              </FormItem>
            </Col>
            <Col span="3">
              <Button type="error" icon="md-trash" @click="handleRemove(index)" v-show="buttonShow">删除</Button>
            </Col>
          </Row>
        </div>
        <Row v-show="buttonShow">
          <Col span="21"></Col>
          <Col span="3">
            <Button type="primary" icon="md-add" @click="handleAdd">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit" v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'bankinfo-info',
  data () {
    return {
      bankRates: [],
      form: {},
      isShow: false,
      buttonShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        name: [
          { required: true, message: '银行名称不允许为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '银行标识不允许为空', trigger: 'blur' }
        ],
        findKey: [
          { required: true, message: '查询银行信息关键字不允许为空', trigger: 'blur' }
        ],
        mailKey: [
          { required: true, message: '邮件查询关键字不允许为空', trigger: 'blur' }
        ],
        beanName: [
          { required: true, message: 'java的bean类不允许为空', trigger: 'blur' }
        ],
        hasSign: [
          { required: true, message: '是否有电子签名不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
        this.bankRates = data.bankRates
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
      this.buttonShow = type === 'update' || type === 'create'
    },
    handleAdd () {
      this.bankRates.push({
        endTime: '',
        startTime: '',
        currentRate: '',
        code: this.form.code
      })
    },
    handleRemove (index) {
      this.bankRates.splice(index, 1)
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.form.bankRates = this.bankRates
      this.$refs.bankinfoForm.validate((valid) => {
        if (valid) {
          console.info(this.form)
          this.P('analyse/bankinfo/updateOrCreateBankInfo', this.form).then(data => {
            this.isShow = false
            this.$emit('handle-search')
          })
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
